<template>
	<modal
		:max-width="modalOptions.largura"
		:max-height="modalOptions.altura"
		:exibir="exibir"
		:custom-actions="false"
		:titulo="tituloModal"
		@close="fecharModal"
		:acao-cancelar="fecharModal"
		:acao-confirmar="salvar"
		nome-botao-confirmar="Salvar"
		:is-confirmar-visivel="listagem.totalItens > 0"
	>
		<template #body>
			<v-row class="py-2">
				<v-col cols="12">
					<span class="font-weight-bold">
						<label-personalizado
							:nome-campo="deveExibirCampoNumeroIntegracaoAtiva ? 'Número Edital' : 'Processo'"
							:obrigatorioPorPadrao="true"
						>
						</label-personalizado>
					</span>
					<span>{{ processoNumero }}</span>
				</v-col>
			</v-row>
			<v-divider></v-divider>
			<modal-adicionar-item-listagem
				:itens-adicionar-ata="listagem.datasource"
				:total-paginas="listagem.totalPaginas"
				:total-itens="listagem.totalItens"
				:paginacao="listagem.paginacao"
				@paginar="paginarItensProcessoListagem"
				@resetar-page="resetarPaginacaoItensProcessoListagem"
			></modal-adicionar-item-listagem>
		</template>
	</modal>
</template>
<script>
import ModalAdicionarItemListagem from '@/views/pages/ata/acessar/gestao-da-ata/itens/adicionar/ModalAdicionarItemListagem.vue'
import { actionTypes, getterTypes, mutationTypes } from '@/core/constants'
import { mapGetters } from 'vuex'

export default {
	name: 'modal-adicionar-item',
	components: {
		ModalAdicionarItemListagem,
	},
	inject: ['idAta'],
	props: {
		exibir: {
			type: Boolean,
		},
	},
	data() {
		return {
			listagem: this.initializeListagem(),
			modalOptions: {
				largura: '80%',
				altura: '80%',
			},
			tituloModal: 'Seleção de Fornecedores do Processo',
			processoNumero: this.$store.state.ata.informacoesAta.processo.numero,
			isIntegracaoWeblicAtivo: this.$store.state.parametrosSistema.isIntegracaoWeblicAtivo,
		}
	},
	computed: {
		...mapGetters({
			itensParaInserirNaAta: getterTypes.ITEM_ATA.ITENS_PARA_INSERIR_NA_ATA,
		}),
		deveExibirCampoNumeroIntegracaoAtiva() {
			return this.isIntegracaoWeblicAtivo
		},
	},
	async mounted() {
		await this.buscarItemProcessoListagem()
	},
	methods: {
		initializeListagem() {
			return {
				datasource: [],
				totalItens: 0,
				totalPaginas: 0,
				paginacao: this.$store.state.itemProcesso.paginacao,
			}
		},
		async buscarItemProcessoListagem() {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.ITEM_PROCESSO.BUSCAR_ITENS_PROCESSOS_LISTAGEM,
			)

			this.setListagem(this.getListaItensProcessosComIds(itens), totalElements, totalPages)
		},
		async paginarItensProcessoListagem(paginacao) {
			this.$store.commit(mutationTypes.ITEM_PROCESSO.SET_PAGINACAO_LISTAGEM, paginacao)
			await this.buscarItemProcessoListagem()
		},
		async adicionarItensSelecionados() {
			const payload = this.itensParaInserirNaAta(this.idAta)
			await this.$store.dispatch(actionTypes.ITEM_ATA.INSERIR_ITEM_ATA_COM_PROCESSO, payload)
		},
		async salvar() {
			if (this.possuiItensSelecionados()) {
				await this.adicionarItensSelecionados()
				await this.buscarItemProcessoListagem()
				await this.recarregarAtaItensListagem()
				this.mostrarNotificacaoSucessoDefault()
				this.fecharModal()
			} else {
				this.mostrarNotificacaoErro('Selecione um item para salvar')
			}
		},
		async resetarPaginacaoItensProcessoListagem() {
			await this.$store.commit(mutationTypes.ITEM_PROCESSO.RESETAR_PAGINA_LISTAGEM)
		},
		fecharModal() {
			this.$emit('fechar-modal')
			this.resetarPaginacaoItensProcessoListagem()
			this.limparItensSelecionados()
		},
		recarregarAtaItensListagem() {
			this.$emit('recarregar-ata-itens-listagem')
		},
		possuiItensSelecionados() {
			return this.$store.state.itemAta.itensParaAdicionarNaAta.length > 0
		},
		limparItensSelecionados() {
			this.$store.commit(mutationTypes.ITEM_ATA.LIMPAR_ITENS_PARA_ADICIONAR)
		},
		setListagem(listaItensProcessosComIds, totalElements, totalPages) {
			this.listagem.datasource = listaItensProcessosComIds
			this.listagem.totalItens = totalElements
			this.listagem.totalPaginas = totalPages
		},
		getListaItensProcessosComIds(lista) {
			return lista.map((item, index) => {
				return {
					...item,
					id: (this.$store.state.itemProcesso.paginacao.page - 1) * 5 + index,
				}
			})
		},
	},
}
</script>

<style scoped lang="stylus">
.bg-white {
	background-color white
}
</style>
